__turbopack_context__.v({
  "active": "Header-module__QnVc9G__active",
  "cartButton": "Header-module__QnVc9G__cartButton",
  "close": "Header-module__QnVc9G__close",
  "closeButton": "Header-module__QnVc9G__closeButton",
  "desktopMenu": "Header-module__QnVc9G__desktopMenu",
  "geoTrigger": "Header-module__QnVc9G__geoTrigger",
  "geoTriggerDesktop": "Header-module__QnVc9G__geoTriggerDesktop",
  "hasSnackbar": "Header-module__QnVc9G__hasSnackbar",
  "inner": "Header-module__QnVc9G__inner",
  "logo": "Header-module__QnVc9G__logo",
  "menu": "Header-module__QnVc9G__menu",
  "menuList": "Header-module__QnVc9G__menuList",
  "mobileMenu": "Header-module__QnVc9G__mobileMenu",
  "mobileMenuLinks": "Header-module__QnVc9G__mobileMenuLinks",
  "mobileMenuSublinks": "Header-module__QnVc9G__mobileMenuSublinks",
  "mobileMenuTrigger": "Header-module__QnVc9G__mobileMenuTrigger",
  "mobileSections": "Header-module__QnVc9G__mobileSections",
  "nav": "Header-module__QnVc9G__nav",
  "navLink": "Header-module__QnVc9G__navLink",
  "navListLast": "Header-module__QnVc9G__navListLast",
  "root": "Header-module__QnVc9G__root",
  "sectionTitle": "Header-module__QnVc9G__sectionTitle",
  "small": "Header-module__QnVc9G__small",
  "trigger": "Header-module__QnVc9G__trigger",
});
